module.exports = __webpack_public_path__ + "img/intro-bg.ca69d040.jpg";